import { MasterImport } from './Import'
const { RoutesMap, CourseList, AddCourse, UpdateCourse, CountryList, CityList, StateList, DistrictList, TehsilList, SessionList, SemesterList, StudentList, UpdateStudent, StudentDetails, SubjectList, DesignationList, DepartmentList, SlotList, AddSlot, UpdateSlot, MasterPaymentList, StaffList, AddStaff, UpdateStaff, CouponList, CouponDetails } = MasterImport

const MasterRoute = () => {
    return [
        {
            path: RoutesMap.COURSE_LIST.path,
            element: <CourseList />
        },

        {
            path: RoutesMap.ADD_COURSE.path,
            element: <AddCourse />
        },

        {
            path: RoutesMap.UPDATE_COURSE.path,
            element: <UpdateCourse />
        },

        {
            path: RoutesMap.COUNTRY_LIST.path,
            element: <CountryList />
        },

        {
            path: RoutesMap.STATE_LIST.path,
            element: <StateList />
        },

        {
            path: RoutesMap.CITY_LIST.path,
            element: <CityList />
        },

        {
            path: RoutesMap.DISTRICT_LIST.path,
            element: <DistrictList />
        },

        {
            path: RoutesMap.TEHSIL_LIST.path,
            element: <TehsilList />
        },

        {
            path: RoutesMap.SESSION_LIST.path,
            element: <SessionList />
        },

        {
            path: RoutesMap.SEMESTER_LIST.path,
            element: <SemesterList />
        },

        {
            path: RoutesMap.STUDENT_LIST.path,
            element: <StudentList />
        },

        // {
        //     path: RoutesMap.ADD_STUDENT.path,
        //     element: <AddStudent />
        // },

        {
            path: RoutesMap.UPDATE_STUDENT.path,
            element: <UpdateStudent />
        },

        {
            path: RoutesMap.STUDENT_DETAILS.path,
            element: <StudentDetails />
        },

        {
            path: RoutesMap.SUBJECT_LIST.path,
            element: <SubjectList />
        },

        {
            path: RoutesMap.DESIGNATION_LIST.path,
            element: <DesignationList />
        },

        {
            path: RoutesMap.DEPARTMENT_LIST.path,
            element: <DepartmentList />
        },

        {
            path: RoutesMap.SLOT_LIST.path,
            element: <SlotList />
        },

        {
            path: RoutesMap.ADD_SLOT.path,
            element: <AddSlot />
        },

        {
            path: RoutesMap.UPDATE_SLOT.path,
            element: <UpdateSlot />
        },

        {
            path: RoutesMap.PAYMENT_MASTER_LIST.path,
            element: <MasterPaymentList />
        },

        {
            path: RoutesMap.COUPON_LIST.path,
            element: <CouponList />
        },

        {
            path: RoutesMap.COUPON_DETAILS.path,
            element: <CouponDetails />
        },

        {
            path: RoutesMap.STAFF_LIST.path,
            element: <StaffList />
        },

        {
            path: RoutesMap.ADD_STAFF.path,
            element: <AddStaff />
        },

        {
            path: RoutesMap.UPDATE_STAFF.path,
            element: <UpdateStaff />
        },
    ]
}

export default MasterRoute;